import {
  openSearchHandler,
  toggleResultsList
} from './search/search';
import {
  changeLangToCurrent,
  getCurrentLangDirection,
} from '../components/langSwitcher/langSwitcher';
import {
  components,
  isDesktop,
  isMobile, isNoMenu,
  isTablet, isWeb,
  projectMode,
  settingsData,
  threeJsVariables, TRoot,
  UIRoot
} from '../../settings';
import {
  autoRotateTimerAction,
  getOrbitControlsCurrentPolarAngle, hideOrbitToMapButton,
} from '../controls/orbitControls';
import { CardTypes, ViewMode } from '../../common';
import gsap from 'gsap';
import {
  createHtmlElement,
  getUrlParam,
  freezingCanvas,
  highlightMenuButtonDependsOnMode, isPageExist, lockScreenOrientation, setCSSVar,
  userPrevent
} from '../../functions';
import {renderUpdateValuesOnDemand} from '../../app';
import {openGetApp} from "./getApp/getApp";
import {
  buttonsWrapperHandler,
  showRightNavBar,
  toggleBackBtnInDesktopMode,
  viewModesSwitching
} from './navigation/right-nav-bar';
import { changeFormTitle, moveFormToBlock } from '../components/form/form';
import { checkMapPanoramaInOrbit } from '../poi/poi';
import { UnitCardClass } from "../cards/unitCards/UnitCardClass";
import { addTechnicalSpecifications, closeOptionsCard } from "../cards/cardsFunctions";
import { enterToTheBuildingWithMaxAvailableApartments } from '../components/building-switch/building_switch';
import {setActiveLordIcon, setLordIcon, toggleIconParams} from '../../lordicon';
import { createMapPage, mapElementStyleToggle } from '../widgets/poi/poiv3';
import { analytics } from '../analytics/analytics';
import { PrivacyAndTerms } from "./PrivacyAndTerms";
import {closeContactWidget} from "../components/chats/chats";
import { BuildingOutline } from '../building/BuildingOutline';
import { SocialMedia } from '../components/share/Share';
import {Button} from "../interfaces/buttons/Button";
import {PopUpPage} from "../interfaces/pages/PopUp";
import {createContactUs} from "./contactUs/contactUs";
import {aboutWidgetInit} from "./about/aboutv3";
import {BaseElement} from "../interfaces/BaseElement";
import { galleryDesktop, resizeGallery } from './gallery/galleryDesktop';
import { Vantages } from '../components/vantage/Vantage';
import { OrbitToMap, transferToBuilding } from '../threejs/camera';
import { Documents } from './documents/Documents';
import { Cloudflare } from '../api/Cloudflare';
import { disposeTiles } from '../threejs/environment';
import { DreamsPreloader } from '../components/preloader/DreamsPreloader';
import { McID, McIDContactUs } from './contactUs/McID';
import { Sound } from '../components/preloader/Sound';
import { CustomerContactNow } from './contactUs/CustomerContactNow';
import { BmbyMode } from '../mode/BmbyMode';
import {IntersectionLegenda} from "../components/IntersectionLegenda";
import { VideoPopUp } from '../components/VideoPopUp';
import { showBuildingLabels } from '../components/building-switch/buildingLabels';
import { Environment } from '../components/Environment/Environment';
import {PWA} from "../components/PWA";

let blockMenuWidthAnimation = false;
export function menuInit (crmSettings) {
  const aside = new BaseElement('aside')
    .addClass('aside__container', isNoMenu ? 'hidden' : null)
    .appendTo(UIRoot);

	if (!isMobile)
		aside.event('transitionend',() => McID.resizeHandler());

  if (isMobile)
    new BaseElement()
      .addClass('substrate', 'background-backdrop-filter', 'aside__substrate')
      .appendTo(aside.DOMElement);
  const topContainer = new BaseElement()
    .addClass('aside__top__container')
    .appendTo(aside.DOMElement);
  const bottomContainer = new BaseElement()
    .addClass('aside__bottom__container')
    .appendTo(aside.DOMElement);
  if (isDesktop) {
    topContainer.addClass('background-backdrop-filter');
    bottomContainer.addClass('background-backdrop-filter');
  }
  const buttonsWrapper = new BaseElement()
    .addClass('buttons-wrapper')
    .appendTo(bottomContainer.DOMElement);
  new SocialMedia(buttonsWrapper.DOMElement, 'domain',false,'top');
  const sound = new Sound();
  sound.addButton(buttonsWrapper.DOMElement,false,'sound-btn--menu');
  const closeButton = new Button()
    .addClass('aside__close-button', 'close-button-cross')
    .event('click', asideHandler)
    .appendTo(topContainer.DOMElement);
  new PrivacyAndTerms({parent: bottomContainer.DOMElement});
  let asideOpened = false;

  addOnClickAsideContainerMinimizerHandler();
  addAsideContainerOnMouseHandlers();

  if (isDesktop) {
    aside.addClass('important-right-side');
    const logo = new BaseElement()
      .addClass('aside__logo')
      .event('click', logoHandler)
      .appendTo(document.body);

    new BaseElement('img')
      .addClass('logo__img')
      .addAttribute('src', Cloudflare.resize(crmSettings.general.logo, {width: 400}))
      .appendTo(logo.DOMElement);
  } else if (crmSettings.general.fullWebsite && !isMobile) {
    closeButton.addClass('hidden');

    const logo = new BaseElement()
      .addClass('aside__logo')
      .event('click', logoHandler)
      .appendTo(topContainer.DOMElement);

    new BaseElement('img')
      .addClass('logo__img')
      .addAttribute('src', Cloudflare.resize(crmSettings.general.logo, {width: 400}))
      .appendTo(logo.DOMElement);

    aside.addClass('important-open-aside-menu');
    asideOpened = true;
  }

  let burgerCopy;
  if (isMobile) {
    const menuLogo = new BaseElement()
      .addClass('aside__logo')
      .appendTo(topContainer.DOMElement);
    new BaseElement('img')
      .addClass('logo__img')
      .appendTo(menuLogo.DOMElement)
      .DOMElement.src = Cloudflare.resize(crmSettings.general.logo, {width: 400});

    burgerCopy = new BaseElement()
      .addClass('burger__mobile__btn', 'icon-more')
      .appendTo(document.body);
    aside.addClass('active-aside-menu');

    mobileAsideMenuReorder(aside.DOMElement);
  }

  let languageSwitcherContainerParent = topContainer.DOMElement;
  if (isDesktop)
    languageSwitcherContainerParent = bottomContainer.DOMElement;
  let languageSwitcherContainer = null;
  if (!isDesktop) {
    languageSwitcherContainer = new BaseElement()
      .addClass('aside__language-switcher')
      .appendTo(languageSwitcherContainerParent);
  }

  const nav = new BaseElement('nav')
    .addClass('aside__navigation__menu')
    .appendTo(topContainer.DOMElement);
  const navList = new BaseElement('ul')
    .addClass('aside__navigation_list', isMobile ? 'background-backdrop-filter' : null)
    .appendTo(nav.DOMElement);

  if (!isDesktop && !config.features?.blockCylinderMode) {
    const dataMenuItem = 'search';
    const searchContainer = new BaseElement('li')
      .addClass('aside__navigation-menu__item', 'aside__search__container', isNoMenu ? 'no-menu-mode' : null)
      .addAttribute('data-menu-item', dataMenuItem)
      .appendTo(isNoMenu ? TRoot : navList.DOMElement);

    if (isNoMenu)
      searchContainer.event('click', async () => {
        const searchContainer = document.querySelector('.search__container-main');
        if (searchContainer) {

          Vantages.isActive() && Vantages.close();
          if (settingsData.activeViewMode === ViewMode.Orbit)
            enterToTheBuildingWithMaxAvailableApartments();
        } else {
          if (settingsData.activeViewMode === ViewMode.Orbit) {
            enterToTheBuildingWithMaxAvailableApartments();
          } else {
            if (Vantages.isActive()) {
              Vantages.close(openSearchHandler);
            } else {
              await openSearchHandler();
            }
          }
        }
      });

    new BaseElement('span')
      .addClass('aside__navigation-menu__text', 'language-string', 'text', 'body')
      .innerHtml(changeLangToCurrent(dataMenuItem))
      .setAttributes({
        'data-menu-item': dataMenuItem,
        'data-dictionary': dataMenuItem
      })
      .appendTo(searchContainer.DOMElement);

    if (isMobile) {
      searchContainer.addClass('mobile-menu-item');
      new BaseElement('span')
        .addClass('aside__navigation-menu__icon', 'icon-search')
        .appendTo(searchContainer.DOMElement);
    } else {
      setLordIcon('search', searchContainer.DOMElement, {trigger: 'hover', delay: '0'})
        .classList.add('aside__navigation-menu__icon');
    }
  } else {
    new BaseElement('button')
      .addClass(
        'menu__back-btn',
        'button-modes',
        'button-modes--back',
        'icon-back',
        'prevent-hide',
        'background-backdrop-filter'
      ).event('click', buttonsWrapperHandler)
      .addAttribute('data-button', 'back')
      .appendTo(isDesktop ? aside.DOMElement : topContainer.DOMElement);
  }

  // const isApplication = getUrlParam('minimap');

  McID.prepareMenuItems(crmSettings.general.menuItems);

  crmSettings.general.menuItems.getApp = true;

  const allActiveMenu = Object.entries(crmSettings.general.menuItems).reduce((acc, value) => {
    if (value[1])
      acc.push(value[0]);
    return acc;
  }, []);

  sortMenuItems(allActiveMenu);

  allActiveMenu.forEach(key => {
    if (!isMobile && (key === 'getApp' || isMobile && key === 'contactUs'))
      return;

    const menuItem = new BaseElement('li')
      .addClass('aside__navigation-menu__item')
      .appendTo(navList.DOMElement);
    if (isMobile) {
      menuItem.addClass(
        'mobile-menu-item',
        'horizontal-separator'
      );
    }

    new BaseElement('span')
      .addClass('aside__navigation-menu__text', 'language-string', 'text', 'body')
      .innerHtml(changeLangToCurrent(key))
      .setAttributes({
        'data-dictionary': key,
        'data-menu-item': key
      })
      .appendTo(menuItem.DOMElement);

    menuItem.addAttribute('data-menu-item', key);

    if (isInAsideMenu(menuItem.DOMElement))
      menuItem.removeClass('horizontal-separator');

    const icon = new BaseElement('span')
      .addClass('aside__navigation-menu__icon')
      .appendTo(menuItem.DOMElement);
    switch (key) {
      case '3dModel':
        isMobile
          ? icon.addClass('icon-home2')
          : setLordIcon('3dModel', menuItem.DOMElement, {trigger: 'hover', delay: '0'});
        break;
      case 'about':
        isMobile
          ? icon.addClass('icon-exclamation-mark')
          : setLordIcon('about', menuItem.DOMElement, {trigger: 'hover', delay: '0'});
        break;
      case 'gallery':
        isMobile
          ? icon.addClass('icon-photo-gallery')
          : setLordIcon('gallery', menuItem.DOMElement, {trigger: 'hover', delay: '0'});
        break;
      case 'specifications':
        isMobile
          ? icon.addClass('icon-engagement')
          : setLordIcon('engagement', menuItem.DOMElement, {trigger: 'hover', delay: '0'});
        break;
      case 'documents':
        isMobile
          ? icon.addClass('icon-document')
          : setLordIcon('documents', menuItem.DOMElement, {trigger: 'hover', delay: '0'});
        Documents.active = true;
        break;
      case 'map':
        isMobile
          ? icon.addClass('icon-location-pin')
          : setLordIcon('map', menuItem.DOMElement, {trigger: 'hover', delay: '0'});
        break;
      case 'contactUs':
        isMobile
          ? icon.addClass('icon-telephone-cross')
          : setLordIcon('contactUs', menuItem.DOMElement, {trigger: 'hover', delay: '0'});

        if (isMobile) {
          menuItem.event('click', () => {
            // closeAsideMenu();

            // const bottomMenuContactUsElement = document.querySelector('.dropdown.mc-id');
            // bottomMenuContactUsElement.classList.add('--rotate-arrow', '--show-dropdown');

            const menuContactUs = McID.scope.find(item => item.id === 'mc-menu');
            if (menuContactUs) {
              menuContactUs.dropdown.show();
              closeAsideMenu();
            }
          });
        }
        break;
      case 'getApp':
        isMobile
          ? icon.addClass('icon-qr-code')
          : setLordIcon('getApp', menuItem.DOMElement, {trigger: 'hover', delay: '0'});
        break;
    }
  });

  if (!config.features?.blockCylinderMode)
    insertSearchBtnToTheCenterOfMenu();

  addMcId(bottomContainer);

  // let mcId;
  // if (!isNoMenu) {
  //   const mcIdData = McID.getData() || {};
  //   if (config.schedulerId && !mcIdData.hasOwnProperty('mcId')) {
  //     mcIdData.mcId = {
  //       guid: config.schedulerId
  //     }
  //   }
  //   mcId = new McID(mcIdData, 'mc-menu');
  // }
  //
  // if (mcId?.container) {
  //   if (isMobile) {
  //     UIRoot.appendChild(mcId.container);
  //   } else {
  //     bottomContainer.DOMElement.insertAdjacentElement('afterbegin',mcId.container);
  //   }
  // }
  //
  // if (!isNoMenu)
  //   !McID.fromDreamsMap && new McIDContactUs();

  addAdditionalMenu(crmSettings.general, burgerCopy?.DOMElement);

  addLanguageSwitcher(languageSwitcherContainer, bottomContainer);
  // if (config.languages.length > 1) {
  //   let langToggleContainer = languageSwitcherContainer?.DOMElement;
  //   if (isDesktop)
  //     langToggleContainer = bottomContainer?.DOMElement;
  //
  //   const langToggle = new BaseElement()
  //     .addClass('header__lang-toggle')
  //     .appendTo(langToggleContainer);
  //   setLordIcon('lang', langToggle.DOMElement, {
  //     trigger: 'hover',
  //     delay:'0'
  //   });
  // }

  if (isMobile)
    removeHorizontalSeparatorFromLastMenuItem();
  setMenuPositionDataAttribute();
  // aside.dataset.initialWidth = asideInitialWidth;
  aside.addAttribute('data-initial-width', isDesktop ? 0 : Math.round(aside.DOMElement.getBoundingClientRect().width))
  animateMenu(aside.DOMElement, burgerCopy?.DOMElement, asideOpened);
  navList.event('click', menuHandler);
  setMenuWidthIntoCssVar();
  setDefaultActiveMenuItem();
}

const addMcId = (parent) => {
  let mcId;
  if (!isNoMenu) {
    const mcIdData = McID.getData() || {};
    if (config.schedulerId && !mcIdData.hasOwnProperty('mcId')) {
      mcIdData.mcId = {
        guid: config.schedulerId
      }
    }
    mcId = new McID(mcIdData, 'mc-menu');
  }

  if (mcId?.container) {
    if (isMobile) {
      UIRoot.appendChild(mcId.container);
    } else {
      parent.DOMElement.insertAdjacentElement('afterbegin',mcId.container);
    }
  }

  if (!isNoMenu)
    !McID.fromDreamsMap && new McIDContactUs();
}

const addLanguageSwitcher = (languageSwitcherContainer, bottomContainer) => {
  if (config.languages.length > 1) {
    let langToggleContainer = languageSwitcherContainer?.DOMElement;
    if (isDesktop)
      langToggleContainer = bottomContainer?.DOMElement;

    const langToggle = new BaseElement()
      .addClass('header__lang-toggle')
      .appendTo(langToggleContainer);
    setLordIcon('lang', langToggle.DOMElement, {
      trigger: 'hover',
      delay:'0'
    });
  }
}

function sortMenuItems (items) {
  const position = {
    "3dModel": 0,
    "about": 1,
    "gallery": 2,
    "documents": 3,
    "map": 4,
    "contactUs": 5
  };

  items.sort((a,b) => {
    const firstPosition = position[a];
    const secondPosition = position[b];

    if (firstPosition < secondPosition) {
      return -1;
    } else if (secondPosition < firstPosition) {
      return  1;
    } else {
      return 0;
    }
  });
}

const setDefaultActiveMenuItem = () => {
  const isAnyActiveMenuItem = Boolean(document.querySelector('.aside__active-menu'));
  if (!isAnyActiveMenuItem)
    setMenuActive('3dModel');
}

const setMenuWidthIntoCssVar = () => {
  const menuElement = document.querySelector('.aside__container');
  const menuWidth = menuElement.getBoundingClientRect().width;
    // document.querySelector(':root').style.setProperty('--webAsideMenuWidth', `${menuWidth}px`);
    setCSSVar('--webAsideMenuWidth', `${menuWidth}px`);
}

const removeHorizontalSeparatorFromLastMenuItem = () => {
  const asideNavigationMenuList = document.querySelector('.aside__navigation_list');
  const itemsHaveHorizontalSeparator = [...asideNavigationMenuList.getElementsByClassName('horizontal-separator')];
  itemsHaveHorizontalSeparator[itemsHaveHorizontalSeparator.length - 1].classList.remove('horizontal-separator');
}

const isInAsideMenu = (item) => {
  if (item.getAttribute('data-menu-item') === 'contactUs')
    return;

  const asideMenuItemsCatalogue = [
    '3dModel',
    'search',
    'map',
    'contactUs',
    'more'
  ];
  const dataMenuItem = item.getAttribute('data-menu-item');

  return asideMenuItemsCatalogue.some(item => {
    return item === dataMenuItem;
  });
}

const mobileAsideMenuReorder = (asideContainer) => {
  const asideTopContainer = asideContainer.querySelector('.aside__top__container');
  const asideBottomContainer = asideContainer.querySelector('.aside__bottom__container');
  const privacyAndTerms = asideBottomContainer.querySelector('.privacy-and-terms');
  asideTopContainer.appendChild(privacyAndTerms);
  asideBottomContainer.remove()
}

export function logoHandler () {
  projectMode.Pagination.paginate({source: 'logoHandler'});
  window.location.reload();
}

function addAdditionalMenu (crm, burgerButton) {
  if (!isMobile || isNoMenu)
    return;

  const container = new BaseElement()
    .addClass('additional-menu__container', 'background-backdrop-filter')
    .appendTo(UIRoot);
  const wrapper = new BaseElement()
    .addClass('additional-menu__wrapper')
    .appendTo(container.DOMElement);
  const shape = new BaseElement()
    .addClass('additional-menu__shape')
    .appendTo(wrapper.DOMElement);
  const nav = new BaseElement('ul')
    .addClass('additional-menu__navigation')
    .event('click', menuHandler)
    .appendTo(shape.DOMElement);

  ['3dModel', 'map', 'search', /*contact*/'contactUs','More'].forEach((btn) => {
    const isContactUs = Boolean(config['crmProjectSettings'].general.menuItems.contactUs);
    if ((btn === 'contactUs' && !isContactUs) || (btn === 'search' && config.features?.blockCylinderMode) /*|| btn === 'contactUs' && McID.fromDreamsMap*/)
      return;

    const li = new BaseElement('li')
      .addClass('additional-menu__item')
      .appendTo(nav.DOMElement);

    if (btn === 'More') {
      burgerButton.setAttribute('data-menu-item', 'More');
      li.DOMElement.appendChild(burgerButton);
    } else {
      setLordIcon(btn, li.DOMElement,{
        trigger: 'hover',
        delay:'0'/*,
        primaryColor: '#ffffff',
        secondaryColor: '#ffffff',*/
      });
    }
    li.addAttribute('data-menu-item', btn);

    const buttonText = document.createElement('span');
    buttonText.classList.add(
      'additional-menu__item-text',
      'language-string',
      'text',
      'menu-icon'
    );
    buttonText.setAttribute('data-dictionary', btn);
    buttonText.innerHTML = changeLangToCurrent(btn);

    li.DOMElement.appendChild(buttonText);
    if (btn === '3dModel')
      li.addClass('additional-menu__active');

    if (btn === 'contactUs') {
      li.DOMElement.querySelector('.lord__icon').classList.add('hidden');
      li.DOMElement.prepend(McID.scope[0].container);
    }
  });

  const fragment = document.createDocumentFragment();
  nav.DOMElement.insertBefore(fragment, nav.DOMElement.childNodes[1]);
}

function insertSearchBtnToTheCenterOfMenu () {
  if (isDesktop) {
    const nav = document.querySelector('.aside__navigation_list');
    const totalElements = nav.childElementCount;
    const searchElementIndex = Math.floor(totalElements / 2);
    const fragment = document.createDocumentFragment();
    const searchContainer = createHtmlElement(fragment, '', 'li', ['aside__navigation-menu__item', 'aside__search__container', 'icon-search']);
    searchContainer.dataset.menuItem = 'search';
    setLordIcon('search',searchContainer,{trigger: 'hover',delay:'0'});
    const searchText = createHtmlElement(searchContainer, changeLangToCurrent(searchContainer.dataset.menuItem), 'span', ['aside__navigation-menu__text', 'language-string', 'text', 'body']);
    searchText.dataset.menuItem = searchContainer.dataset.menuItem;
    searchText.setAttribute('data-dictionary', searchContainer.dataset.menuItem);
    nav.insertBefore(fragment, nav.childNodes[searchElementIndex]);
  }
}

export function setMenuPositionDataAttribute () {
  const menu = document.querySelector('.aside__container');
  const currentDirection = getCurrentLangDirection();

  if (isDesktop) {
    menu.dataset.menuPosition = 'right';
  } else {
    switch (currentDirection) {
      case 'rtl':
        menu.dataset.menuPosition = 'right';
        break;
      case 'ltr':
        menu.dataset.menuPosition = 'left';
        break;
    }
  }
}

export function changeMenuStyle () {
  const burgerMenu = document.querySelector('.aside__burger__btn');
  if (!isMobile || !burgerMenu) {
    return;
  }

  switch (settingsData.activeViewMode) {
    case ViewMode.Orbit:
      const angle = getOrbitControlsCurrentPolarAngle();
      angle < 1 ?
        burgerMenu.classList.add('menu__substrate'):
        burgerMenu.classList.remove('menu__substrate');
      break;
    case ViewMode.Cylinder:
      burgerMenu.classList.add('menu__substrate');
      break;
  }
}

export function getActiveMenuData () {
  if (isMobile) {
    return document.querySelector('.additional-menu__active')?.dataset.menuItem;
  } else {
    return document.querySelector('li.aside__active-menu')?.dataset.menuItem;
  }
}

export async function menuHandler (e) {
  // change/remove this as well if you changed specifications lordIcon
  if (e.target.dataset.menuItem === 'document' || e.target.dataset.menuItem === 'engagement')
    e.target.dataset.menuItem = 'specifications';

  let menuItem = e.target.dataset.menuItem;

  if (!e.target.dataset.menuItem) {
    const closestDataMenuItem = e.target.closest('[data-menu-item]');
    if (!closestDataMenuItem)
      return;
    menuItem = closestDataMenuItem.getAttribute('data-menu-item');
  }

  const isCylinderBlockedInMobile = config.features?.blockCylinderMode && isMobile;
  const isCurrentItemIsSelected = getActiveMenuData() === menuItem;
  const isCurrentItemContactUsInMobile = isMobile && (menuItem === 'contactUs');
  const isFromApplyNow = Boolean(e.target.dataset?.isFromApplyNow);
  if ((isCylinderBlockedInMobile && menuItem === 'search') || isCurrentItemIsSelected || (isCurrentItemContactUsInMobile && McID.active && !isFromApplyNow))
    return;

  const isTargetMore = menuItem === 'More';
  const isTargetPlayBouncy = menuItem === 'playBouncy';
  if (!isTargetMore && !isTargetPlayBouncy)
    closeContactWidget();

  if (!userPrevent())
    projectMode.Pagination.paginate({source: 'menuHandler', menuItem: menuItem});
  if (document.querySelector(`.${CardTypes.Options}-card`)) {
    if (document.querySelector('.form__container-main'))
      moveFormToBlock();
    if (!isMobile && e.target.dataset.menuItem !== 'contactUs')
      closeOptionsCard();
  }
  if (document.querySelector(`.apply__main-container:not(.chats)`))
    document.querySelector(`.apply__main-container:not(.chats)`).remove();
  if (!threeJsVariables.orbitControls.enabled && !settingsData.tourIsActive && !projectMode.LiteMode.isActive() && !projectMode.AirMode.active)
    return;


  const gallerySelector = '.pop-up-page.gallery';
  const isMobileGalleryActive = isMobile && document.querySelector(gallerySelector);
  const isTargetIsHtmlElement = isMobile && e.target instanceof HTMLElement;
  if (!isTargetMore && (isTargetIsHtmlElement || !isMobileGalleryActive) && !isTargetPlayBouncy)
    PopUpPage.hide();

  let orbitPanorama;
  const streetView = document.querySelector('.map__panorama');

  if (VideoPopUp.isPlaying() && !isMobile) {
    VideoPopUp.shrink();
  } else if (!isNoMenu) {
    VideoPopUp.close();
  }

  freezingCanvas(false);

  switch (menuItem) {
    case 'search':
      if (userPrevent() || projectMode.LiteMode.preventPointerEvents() || settingsData.loadingError)
        return;

      if (settingsData.activeViewMode === ViewMode.Orbit)
        removeAsideContainerOnMouseHandlers();
      closeOptionsCard_localFunction();
      hideOrbitToMapButton();
      orbitPanorama = checkMapPanoramaInOrbit();
      orbitPanorama && orbitPanorama.classList.remove('map__panorama__orbit__show');
      streetView && streetView.classList.remove('map__panorama__show');
      settingsData.resolveTilesUpdate = true;
      renderUpdateValuesOnDemand(false);
      closePages();
      toggleResultsList('close');

      const searchContainer = document.querySelector('.search__container-main');
      if (searchContainer) {
        Vantages.isActive() && Vantages.close();
        if (settingsData.activeViewMode === ViewMode.Orbit)
          enterToTheBuildingWithMaxAvailableApartments();
      } else {
        if (settingsData.activeViewMode === ViewMode.Orbit) {
          enterToTheBuildingWithMaxAvailableApartments().then(isEntered => {
            if (!isEntered) {
              menuItem = null;
            }

          });
        } else {
          if (Vantages.isActive()) {
            Vantages.close(openSearchHandler);
          } else {
            !isMobile && await openSearchHandler().then(() => {
              setMenuActive(menuItem);
            });
          }
        }
      }

      await threeJsVariables.cloth.removeCloth();
      setMenuActive(menuItem);

      if (isDesktop)
        floorSliderVisibility('show');

      analytics('page_entrance','search');
      closeAsideMenu();
      break;
    case '3dModel':
      if (userPrevent() || projectMode.LiteMode.preventPointerEvents())
        return;

      closeOptionsCard_localFunction();
      projectMode.LiteMode.setDefaultPosition();

      orbitPanorama = checkMapPanoramaInOrbit();
      if (orbitPanorama)
        orbitPanorama.classList.remove('map__panorama__orbit__show');
      if (streetView)
        streetView.classList.remove('map__panorama__show');
      settingsData.resolveTilesUpdate = true;
      renderUpdateValuesOnDemand(false);
      closePages();
      closeAsideMenu();
      if (settingsData.activeViewMode !== ViewMode.Orbit) {
        if (Vantages.isActive()) {
          Vantages.close(() => viewModesSwitching(ViewMode.Orbit));
        } else {
          await viewModesSwitching(ViewMode.Orbit);
        }
        if (isMobile && components.mobileSearch) {
          components.mobileSearch.remove();
          components.mobileSearch = null;
        }
      } else {
        const mapIsActive = isMobile ?
          document.querySelector('.additional-menu__item[data-menu-item="map"].additional-menu__active') :
          document.querySelector('li[data-menu-item="map"].aside__active-menu');
        if (mapIsActive && e instanceof Event) {
          toggleAsideMenu(menuItem);
          await transferToBuilding()
        }
        toggleBackBtnInDesktopMode('hide');
        setMenuActive(menuItem);
      }

      if (e instanceof Event)
        BuildingOutline.toggle(true);

      lockScreenOrientation();

      analytics('page_entrance','3dModel');
      break;
    case 'documents':
      if (userPrevent() || projectMode.LiteMode.preventPointerEvents() || !Documents.active)
        return;

      let documentsPage = document.querySelector('.documents-page');
      if (!documentsPage) {
        documentsPage = new PopUpPage('documents');
        documentsPage.addClass('documents-page');
        documentsPage.titleIcon = 'icon-document';
        new Documents(documentsPage.contentElement).create();
      } else {
        documentsPage.classList.remove('hidden');
      }

      PopUpPage.animation('show');

      if (isDesktop)
        showRightNavBar();

      setMenuActive(menuItem);
      closeAsideMenu();
      analytics('page_entrance','documents');
      break;
    case 'contactUs':
      if (userPrevent())
        return;

      const contactUs = document.querySelector('.contact-us');
      if (!contactUs) {
        const contactUsPage = new PopUpPage('Contact us');
        contactUsPage.addClass('contact-us');
        contactUsPage.titleIcon = 'icon-call';
        createContactUs(contactUsPage.contentElement);
      } else {
        contactUs.classList.remove('hidden');

        let formParent, formPosition;

        if (CustomerContactNow.isActive) {
          formParent = document.querySelector('.contact-us__content');
          formPosition = 'afterbegin';
        } else {
          formParent = document.querySelector('.contact-us__contacts');
          formPosition = 'afterend';
        }

        moveFormToBlock(formParent, formPosition);
        changeFormTitle('leadFormTitle');
        const form = document.querySelector('.form__container-main');
        if (form)
          form.querySelector('input[type="email"]')?.parentElement.classList.remove('hidden');
      }
      PopUpPage.animation('show');

      orbitPanorama = checkMapPanoramaInOrbit();
      if (orbitPanorama)
        orbitPanorama.classList.remove('map__panorama__orbit__show');
      setMenuActive(menuItem);
      closeAsideMenu();
      analytics('page_entrance','contactUs');
      break;
    case 'getApp':
      if (userPrevent())
        return;

      const installHelper = new window.AddToHomeScreen(
          {
            appName: config.projectTitle,
            appIconUrl: PWA.icon,
            assetUrl: './img/pwa/',
            showErrorMessageForUnsupportedBrowsers: window.AddToHomeScreen.SHOW_ERRMSG_UNSUPPORTED.NONE,
            allowUserToCloseModal: false,
            maxModalDisplayCount: -1,
          });
      installHelper.show();

      const container = document.querySelector('.adhs-container');

      if (container) {
        const modal = container.querySelector('.adhs-modal');
        new BaseElement('button')
            .addClass('button','pwa__close-modal-btn')
            .innerHtml('Close')
            .event('click',() => container.remove())
            .appendTo(modal);
      }

      // orbitPanorama = checkMapPanoramaInOrbit();
      // if (orbitPanorama)
      //   orbitPanorama.classList.remove('map__panorama__orbit__show');
      // const getApp = document.querySelector('.get-app-popup');
      // if (!getApp) {
      //   if (!isMobile) {
      //     const getApp = new PopUpPage('Get app');
      //     getApp.titleIcon = 'icon-qr-code';
      //     openGetApp(getApp.contentElement);
      //     setMenuActive(e.target.dataset.menuItem);
      //   } else {
      //     openGetApp();
      //     highlightMenuButtonDependsOnMode();
      //   }
      // } else {
      //   getApp.classList.remove('hidden');
      // }
      // !isMobile && PopUpPage.animation('show');
      // closeAsideMenu();
      // analytics('page_entrance','getApp');
      break;
    case 'about':
      if (userPrevent())
        return;

      const isAboutWebViewUrl = config.crmProjectSettings.general?.aboutWebviewURL;
      const aboutUs = document.querySelector('.about-us');
      if (!aboutUs) {
        const aboutUs = new PopUpPage('About');
        aboutUs.addClass('about-us');
        aboutUs.titleIcon = 'icon-exclamation-mark';

        if (isAboutWebViewUrl) {
          new BaseElement('iframe')
            .addClass('about-web-view-url')
            .setAttributes({
              'src': isAboutWebViewUrl
            })
            .appendTo(aboutUs.contentElement);
        } else if (!config.widgets?.about) {
          const preloader = new DreamsPreloader(aboutUs.contentElement);
          preloader.show();
          const awaitAboutResponse = setInterval(() => {
            if (config.widgets?.about) {
              clearInterval(awaitAboutResponse);
              preloader.remove();
              aboutWidgetInit(aboutUs.contentElement);
            }
          },100);
        } else {
          aboutWidgetInit(aboutUs.contentElement);
        }
      } else {
        aboutUs.classList.remove('hidden');
      }
      Vantages.isActive() && Vantages.close();
      PopUpPage.animation('show');

      if (isDesktop)
        showRightNavBar();

      orbitPanorama = checkMapPanoramaInOrbit();
      if (orbitPanorama)
        orbitPanorama.classList.remove('map__panorama__orbit__show');
      if (isMobile)
        playDownAllMenuButtons();
      if (!isMobile)
        setMenuActive(menuItem);
      closeAsideMenu();
      analytics('page_entrance',menuItem);
      break;
    case 'gallery':
      if (userPrevent())
        return;

      const isGalleryWebViewUrl = config.crmProjectSettings.general?.galleryWebviewURL;
      const gallery = document.querySelector('.gallery');
      if (!gallery) {
        const gallery = new PopUpPage('Gallery');
        gallery.addClass('gallery');
        gallery.titleIcon = 'icon-photo-gallery';

        if (isGalleryWebViewUrl) {
          new BaseElement('iframe')
            .addClass('gallery-web-view-url')
            .setAttributes({
              'src': isGalleryWebViewUrl
            })
            .appendTo(gallery.contentElement);
        } else if (!config.widgets?.gallery) {
          const preloader = new DreamsPreloader(gallery.contentElement);
          preloader.show();
          const awaitGalleryResponse = setInterval(() => {
            if (config.widgets?.gallery) {
              clearInterval(awaitGalleryResponse);
              preloader.remove();
              galleryDesktop(gallery.contentElement);
            }
          },100);
        } else {
          galleryDesktop(gallery.contentElement);
        }
      } else {
        gallery.classList.remove('hidden');
        if (!isGalleryWebViewUrl && isMobile)
          resizeGallery();
      }

      Vantages.isActive() && Vantages.close();
      PopUpPage.animation('show');

      if (isDesktop)
          showRightNavBar();

      orbitPanorama = checkMapPanoramaInOrbit();
      if (orbitPanorama)
        orbitPanorama.classList.remove('map__panorama__orbit__show');
      if (isMobile)
        playDownAllMenuButtons();
      if (!isMobile)
        setMenuActive(menuItem);
      closeAsideMenu();
      analytics('page_entrance',menuItem);
      break;
    case 'specifications':
      if (userPrevent())
        return;

      const specifications = document.querySelector('.pop-up-page.specifications');
      if (!specifications) {
        const specifications = new PopUpPage('specifications');
        specifications.addClass('specifications');
        specifications.titleIcon = 'icon-engagement';
        const content = specifications.contentElement;
        addTechnicalSpecifications(null, content);
        const specsBlock = content.children[1];
        specsBlock.className  = 'specifications background-backdrop-filter';
        specsBlock.children[0].remove();
      } else {
        specifications.classList.remove('hidden');
      }

      Vantages.isActive() && Vantages.close();
      PopUpPage.animation('show');

      if (isDesktop)
        showRightNavBar();

      orbitPanorama = checkMapPanoramaInOrbit();
      if (orbitPanorama)
        orbitPanorama.classList.remove('map__panorama__orbit__show');
      if (isMobile)
        playDownAllMenuButtons();
      if (!isMobile)
        setMenuActive(menuItem);
      closeAsideMenu();
      analytics('page_entrance',menuItem);
      break;
    case 'playBouncy':
      if (userPrevent())
        return;
      VideoPopUp.open();
      analytics('page_entrance','Video');
      break;
    case 'More':
      if (userPrevent())
        return;

      const asideMenu = document.querySelector('.aside__container');
      asideMenu.classList.toggle('mobile-menu__show');

      if (asideMenu.classList.contains('mobile-menu__show')) {
        // PopUpPage.hide();
        setMenuActive(menuItem);
        asideMenuAnimation('show');
      } else {
        asideMenuAnimation('hide');
        highlightMenuButtonDependsOnMode();
      }
    break;
    case 'map':
      if (userPrevent())
        return;

      const mapContainer = createMapPage();
      Vantages.isActive() && Vantages.close();
      closeOptionsCard_localFunction();
      if (settingsData.buildingDestroyed) {
        closeAsideMenu();
        await projectMode.FloorPlan.exitFromMode();
        if (settingsData.activeViewMode !== ViewMode.Orbit)
          await viewModesSwitching(ViewMode.Orbit);
      }

        if (isDesktop &&
          settingsData.buildingDestroyed &&
          (e.target.dataset.menuItem === 'gallery' || e.target.dataset.menuItem === 'about'))
            floorSliderVisibility('hide');

        toggleBackBtnInDesktopMode('show');

      if (settingsData.activeViewMode === ViewMode.Orbit && e instanceof Event ) {
        await OrbitToMap(false);
        renderUpdateValuesOnDemand(true);
      }

      const page = getActivePage();
      if (page && page.dataset.menuItem !== menuItem) {
        openPage(menuItem);
        setTimeout(()=>{
          closePages(page);
        },100)
      } else {
        openPage(menuItem);
      }

      if (!config.widgets?.poi) {
        const preloader = new DreamsPreloader(mapContainer);
        preloader.show();
        const awaitPoiResponse = setInterval(() => {
          if (config.widgets?.poi) {
            clearInterval(awaitPoiResponse);
            preloader.remove();
          }
        },100);
      }

      setMenuActive(menuItem);
      closeAsideMenu();
      setTimeout(()=>{
        orbitPanorama = checkMapPanoramaInOrbit();
        orbitPanorama && orbitPanorama.classList.remove('map__panorama__orbit__show');
        streetView && streetView.classList.remove('map__panorama__show');
        renderUpdateValuesOnDemand(true);
        disposeTiles();
      },100);
      analytics('page_entrance',menuItem);
      break;
    default:
      if (menuItem) {
        if (userPrevent())
          return;

        toggleBackBtnInDesktopMode('show');

        const page = getActivePage();
        if (page && page.dataset.menuItem !== menuItem) {
          openPage(menuItem);
          setTimeout(()=>{
            closePages(page);
          },100)
        } else {
          openPage(menuItem);
        }
        Vantages.isActive() && Vantages.close();
        setMenuActive(menuItem);
        setMenuActive(e.target.dataset.menuItem);
        closeAsideMenu();
        renderUpdateValuesOnDemand(true);
        setTimeout(()=>{
          orbitPanorama = checkMapPanoramaInOrbit();
          orbitPanorama && orbitPanorama.classList.remove('map__panorama__orbit__show');
          streetView && streetView.classList.remove('map__panorama__show');
        },100);
        analytics('page_entrance',menuItem);
      }
      break;
  }

  if (isDesktop) {
    menuItem !== '3dModel'
      ? setMenuElementsState('hidden')
      : setMenuElementsState('visible');
  }

  toggleAsideMenu(menuItem);

  autoRotateTimerAction('update');
  const compareBlock = document.querySelector(`.compare-block`);
  if (compareBlock)
    compareBlock.remove();

  function closeOptionsCard_localFunction() {
    if (document.querySelector(`.${CardTypes.Options}-card`)) {
      if (document.querySelector('.form__container-main'))
        moveFormToBlock();
      closeOptionsCard();
    }
  }
}

export function setMenuElementsState(state) {
  const elementsToSet = [
    document.querySelector('.joystick'),
    document.querySelector('.bottom__nav-bar'),
    document.querySelector('.contact-widget__main-container')
  ];

  if (settingsData.activeViewMode !== ViewMode.Orbit)
    elementsToSet.pop();

  switch(state) {
    case 'hidden':
      elementsToSet.forEach(element => { element?.classList.add('hidden') });
      IntersectionLegenda.hide();
      break;
    case 'visible':
      elementsToSet.forEach(element => { element?.classList.remove('hidden') });
      IntersectionLegenda.show();
      break;
  }
}

const asideMenuAnimation = (action) => {
  const asideMenu = document.querySelector('.aside__container');

  const asideParts = {
    substrate: asideMenu.querySelector('.aside__substrate'),
    logo: asideMenu.querySelector('.aside__logo'),
    language: asideMenu.querySelector('.aside__language-switcher'),
    closeButton: asideMenu.querySelector('.aside__close-button'),
    navigationMenu: asideMenu.querySelector('.aside__navigation__menu'),
    privacyAndTerms: asideMenu.querySelector('.privacy-and-terms')
  }
  switch (action) {
    case 'show':
      gsap.from([asideParts.logo, asideParts.language, asideParts.closeButton], {y: -1000, duration: 0.5});
      gsap.from([asideParts.navigationMenu, asideParts.privacyAndTerms], {y: 1000, duration: 0.5});
      gsap.to(asideParts.substrate, {opacity: 1, duration: 0.5});
      break;
    case 'hide':
      gsap.to(asideParts.substrate, {opacity: 0});
      break;
    default:
      console.log('asideMenuAnimation default case');
      break;
  }
}

export const toggleAsideMenu = (menuItem) => {
  if (!Boolean(menuItem))
    return;

  if (menuItem !== '3dModel' && settingsData.activeViewMode === ViewMode.Cylinder) {
    toggleMenuWidth({action: 'mini', source: 'eventListener'});
  } else if (settingsData.activeViewMode === ViewMode.Orbit) {
    if (menuItem !== '3dModel') {
      toggleMenuWidth({action: 'mini', source: 'orbit'});
    } else {
      toggleMenuWidth({action: 'full-force', source: 'orbit'});
    }
  }
}

export const floorSliderVisibility = (parameter) => {
    const floorSliderDesktop = document.querySelector('.floor-slider__desktop');
    if (!floorSliderDesktop)
      return;

    switch (parameter) {
      case 'hide':
        floorSliderDesktop.classList.add('hidden');
        break;
      case 'show':
        floorSliderDesktop.classList.remove('hidden');
        break;
    }
}

export function closePages (page) {
  const activePage = page || document.querySelector('.widget__container.show-page');
  if (activePage) {
    activePage.classList.remove('show-page');
  }
  mobileBurgerStyleToggle();
  mapElementStyleToggle(activePage);
}

function getActivePage () {
  return document.querySelector('.widget__container.show-page');
}

export function asideHandler() {
  const aside = document.querySelector('.aside__container');

  if (!isMobile)
    aside.classList.toggle('active-aside-menu');

  if (aside.classList.contains('mobile-menu__show'))
    aside.classList.remove('mobile-menu__show');

  if (isMobile) {
    toggleBurgerButton();
    asideMenuAnimation('hide');
    PopUpPage.hide();
    highlightMenuButtonDependsOnMode();
    lockScreenOrientation();
  }
}

export function setMenuActive (data) {
  if (BmbyMode.active)
    return;
  if (isMobile) {
    playDownAllMenuButtons();
    highlightActiveButton(data);
  } else {
    const activeMenu = UIRoot.querySelector('li.aside__active-menu');
    const selectedMenu = UIRoot.querySelector('li[data-menu-item="' + data + '"]');
    if (activeMenu)
      activeMenu.classList.remove('aside__active-menu');
    if (selectedMenu)
      selectedMenu.classList.add('aside__active-menu');

    setActiveLordIcon(data, document.querySelector('.aside__navigation_list'));
  }

  toggleAsideMenu(data);
}

const toggleBurgerButton = () => {
  const burgerButton = document.querySelector('[data-menu-item="More"]');
  if (!burgerButton)
    return;

  const icon = burgerButton.querySelector('.burger__mobile__btn');
  const text = burgerButton.querySelector('.additional-menu__item-text');
  icon.classList.toggle('active');
  text.classList.toggle('active');
}

export const playDownAllMenuButtons = () => {
  if (isNoMenu)
    return;

  const bottomMenu = document.querySelector('.additional-menu__navigation');
  const activeButtons = document.querySelectorAll('.additional-menu__active');
  const activeElements = bottomMenu.querySelectorAll('.active');
  const activeLordIcons = bottomMenu.querySelectorAll('[activeicon="true"]');
  for (let i = 0; i < activeElements.length; i++) {
    activeElements[i].classList.remove('active');
  }
  for (let i = 0; i < activeLordIcons.length; i++) {
    toggleIconParams(activeLordIcons[i]);
  }
  for (let i = 0; i < activeButtons.length; i++) {
    activeButtons[i].classList.remove('additional-menu__active');
  }
}

export const highlightActiveButton = (data) => {
  const activeButton =
    data ?
      document.querySelector(`.additional-menu__item[data-menu-item="${data}"]`) :
      document.querySelector('.additional-menu__active');
  if (!data || !activeButton)
    return;
  const activeButtonText = activeButton.querySelector('.additional-menu__item-text');
  const activeButtonIconName = activeButton.getAttribute('data-menu-item');
  activeButton.classList.add('additional-menu__active');
  activeButtonText.classList.add('active');
  setActiveLordIcon(activeButtonIconName, activeButton);
}

export function closeAsideMenu () {
  if (BmbyMode.active || isNoMenu)
    return;

  const menu = document.querySelector('.aside__container');
  const additionalMenu = document.querySelector('.additional-menu__container');

  if (isMobile) {
    menu && menu.classList.remove('mobile-menu__show');
    additionalMenu && additionalMenu.querySelector('[data-menu-item="More"]')?.classList.remove('additional-menu__active');
  } else {
    menu && menu.classList.remove('active-aside-menu');
  }
}

export function openPage (data) {
  const pageExist = isPageExist(data);
  if (pageExist) {
    pageResize(pageExist);
    mapElementStyleToggle(pageExist);
    pageExist.classList.add('show-page');
    mobileBurgerStyleToggle();
  }
}

export function pageResize (page) {
  if (BmbyMode.active || !page)
    return;
  if (isDesktop) {
    page.style.removeProperty('padding-top');

    return;
  }

  // const direction = getCurrentLangDirection();
  // let paddingLang = direction === 'ltr' ? 'paddingLeft' : 'paddingRight';
  // let menuWidth = 56;

  if (page.firstElementChild)
    page.firstElementChild.style.removeProperty('padding-left');
  if (page.firstElementChild)
    page.firstElementChild.style.removeProperty('padding-right');
  page.style.removeProperty('margin-right');
  page.style.removeProperty('margin-left');
  page.style.removeProperty('padding-left');
  page.style.removeProperty('padding-right');

  if (!isMobile) {
    if (isDesktop)
      // paddingLang = 'paddingRight';

    page.style.paddingTop = 0;
    // page.style[paddingLang] = menuWidth + 'px';
  }
}

export function mobileBurgerStyleToggle () {
  const burger = document.querySelector('.burger__mobile__btn');
  const widgetPageIsOpened = document.querySelector('.widget__container.show-page');
  const contactUs = document.querySelector('.contact-us');
  const search = document.querySelector('.search__container-main');
  const poiCardInOrbit = document.querySelector('.poi__info-window.orbit__mode');

  const moduleOpen = widgetPageIsOpened || contactUs || search || poiCardInOrbit;

  if (moduleOpen && burger) {
    burger.classList.add('mobile-burger__white');
  } else if (burger && settingsData.activeViewMode === ViewMode.Cylinder) {
    burger.classList.add('mobile-burger__white');
  } else if (burger && settingsData.activeViewMode === ViewMode.Orbit) {
    burger.classList.remove('mobile-burger__white');
  } else if (!moduleOpen && burger && burger.classList.contains('mobile-burger__white')) {
    burger.classList.remove('mobile-burger__white');
  }
}

export function updatePagesStyle () {
  const pages = document.querySelectorAll('.content__page');
  pages.forEach(page => {
    pageResize(page);
  });
}

function animateMenu (menu, burger, param) {
  if (param) {
    menu.style.opacity = 1;
    return;
  }
  const langDirection = getCurrentLangDirection();
  let side = langDirection === 'ltr' ? 'left' : 'right';

  if (isDesktop)
    side = 'bottom';

  if (isMobile) {
    menu.style.opacity = 1;
    gsap.fromTo(burger, {[side]: -200, opacity: 0}, {
      [side]: 15, opacity: 1, duration: 1, onComplete: () => {
        resetMenuAnimation(burger);
      },
    });

    return;
  }
  gsap.fromTo(menu, {[side]: -200, opacity: 0}, {
    [side]: 0, opacity: 1, duration: 1, onComplete: () => {
      resetMenuAnimation();
    },
  });
}

export function resetMenuAnimation (menu) {
  const menuElement = menu || document.querySelector('.aside__container');
  menuElement.style.removeProperty('left');
  menuElement.style.removeProperty('right');
  menuElement.style.removeProperty('bottom');
}

export function additionalMenuToggle () {
  if (!isMobile) {
    return;
  }

  const additionalMenu = document.querySelector('.additional-menu__container');
  if (!additionalMenu) {
    return;
  }

  if (settingsData.isLandscape && settingsData.activeViewMode === ViewMode.Orbit) {
    additionalMenu.style.display = 'block';
  } else if (!settingsData.isLandscape) {
    additionalMenu.style.display = 'block';
  }
}

let toggleMenuWidthTimeout = null;
let prevMenuAnimation = null;

function preventMenuAnimation () {
  if (prevMenuAnimation) {
    prevMenuAnimation.kill();
    prevMenuAnimation = null;
  }
}

export function toggleMenuWidth(props) {
  if (BmbyMode.active)
    return;

  const ANIMATION_DURATION = 0.05;
  const {action, source} = props;
  const asideContainer = document.querySelector('.aside__container');
  const search = document.querySelector('.search__container-main');
  const asideNavigationMenuItem = [...asideContainer?.getElementsByClassName('aside__navigation-menu__item') || []];
  const isHomeMenuButtonActive =
    Boolean(document.querySelector(
      '.aside__navigation-menu__item.aside__active-menu[data-menu-item="3dModel"]'
    ));
  const isAnyMenuButtonActive = Boolean(document.querySelectorAll('.aside__active-menu'));
  if (isMobile || isDesktop || !asideContainer || blockMenuWidthAnimation)
    return;

  preventMenuAnimation();

  if (source === 'cylinder' || source === 'orbit') {
    switch (action) {
      case 'full':
        if (!asideContainer.classList.contains('minimized'))
          return;
        prevMenuAnimation = gsap.to(
          asideContainer, {
            width: 230,
            duration: ANIMATION_DURATION,
            onComplete: () => {
              asideContainer.style.position = '';
              if (search)
                search.style.marginInlineStart = '';

              asideContainer.style.padding = '22px 30px 8px 30px';
              asideContainer.classList.remove('minimized');
            }
          }
        );
        toggleElementsVisibility('show');
        asideNavigationMenuItem.forEach(item => item.style.removeProperty('justify-content'));
        break;
      case 'full-force':
        prevMenuAnimation = gsap.to(
          asideContainer, {
            width: 230,
            duration: ANIMATION_DURATION,
            onComplete: () => {
              asideContainer.style.position = '';
              if (search)
                search.style.marginInlineStart = '';

              asideContainer.style.padding = '22px 30px 8px 30px';
              asideContainer.classList.remove('minimized');
            }
          }
        );
        toggleElementsVisibility('show');
        asideNavigationMenuItem.forEach(item => item.style.removeProperty('justify-content'));
        break;
      case 'mini':
        if (isHomeMenuButtonActive || !isAnyMenuButtonActive || asideContainer.classList.contains('minimized'))
          return;
        prevMenuAnimation = gsap.to(
          asideContainer, {
            width: 56,
            duration: ANIMATION_DURATION,
            onComplete: () => {
              asideContainer.style.padding = '22px 8px';
              asideContainer.classList.add('minimized');
            }
          }
        );
        toggleElementsVisibility('hide');
        asideNavigationMenuItem.forEach(item => item.style.justifyContent = 'center');
        break;
    }
  } else if (source === 'eventListener') {
    const dummy = {value: 0};
    switch (action) {
      case 'full':
        prevMenuAnimation = gsap.to(dummy, {value: 1, duration: ANIMATION_DURATION, onStart: () => {
            if (asideContainer.classList.contains('minimized')) {
              asideContainer.style.position = 'fixed';
              if (search && !isNoMenu)
                search.style.marginInlineStart = '56px';
            }
          },onComplete: () => {
            asideContainer.style.removeProperty('width');
            asideContainer.style.padding = '22px 30px 8px 30px';
            toggleElementsVisibility('show');
            asideNavigationMenuItem.forEach(item => item.style.removeProperty('justify-content'));
            asideContainer.classList.remove('minimized');
          }});
        break;
      case 'mini':
        if (isHomeMenuButtonActive || !isAnyMenuButtonActive || asideContainer.classList.contains('minimized'))
          break;

        prevMenuAnimation = gsap.to(dummy, {value: 1, duration: ANIMATION_DURATION, onComplete: () => {
            asideContainer.style.width = '56px';
            asideContainer.style.padding = '22px 8px';
            toggleElementsVisibility('hide');
            asideNavigationMenuItem.forEach(item => item.style.justifyContent = 'center');
            asideContainer.classList.add('minimized');
          }});
        break;
    }
  }
}

const toggleElementsVisibility = (action) => {
  const asideContainer = document.querySelector('.aside__container');
  const asideBottomContainer = asideContainer.querySelector('.aside__bottom__container');
  const languageSwitcher = asideContainer.querySelector('.aside__language-switcher');
  const asideNavigationsText = [...asideContainer.getElementsByClassName('aside__navigation-menu__text')];
  const contactWidget = asideBottomContainer.querySelector('.contact-widget__main-container');
  const mcIdContacts = asideBottomContainer.querySelector('.mc-id-contacts');
  // const share = asideContainer.querySelector('.share-dropdown__content-wrapper');

  switch(action) {
    case 'show':
      [...asideBottomContainer.children].forEach(child => {
        child.classList.remove('hidden');
      });
      contactWidget && contactWidget.classList.remove('minimized');
      mcIdContacts && mcIdContacts.classList.remove('minimized');
      // share && share.classList.remove('hidden');
      languageSwitcher.classList.remove('hidden');
      asideNavigationsText.forEach(text => text.classList.remove('hidden'));
      break;
    case 'hide':
      [...asideBottomContainer.children].forEach(child => {
        if (child !== contactWidget && child !== mcIdContacts)
          child.classList.add('hidden');
      });
      contactWidget && contactWidget.classList.add('minimized');
      mcIdContacts && mcIdContacts.classList.add('minimized');
      languageSwitcher.classList.add('hidden');
      // share && share.click();
      asideNavigationsText.forEach(text => text.classList.add('hidden'));
      break;
  }
}

let timeoutOnOpenID;
const onMouseOverAsideContainerHandler = () => {
  const asideContainer = document.querySelector('.aside__container');
  if (!asideContainer)
      return;

  timeoutOnOpenID = setTimeout(() => {
    toggleMenuWidth({action: 'full', source: 'eventListener'});
  }, 200);
  // toggleMenuWidth({action: 'full', source: 'eventListener'});
}

const onMouseOutAsideContainerHandler = () => {
  const asideContainer = document.querySelector('.aside__container');
  // const homeButton = asideContainer.querySelector('[data-menu-item="3dModel"]');
  if (!asideContainer || userPrevent())
      return;

  clearTimeout(timeoutOnOpenID);
  toggleMenuWidth({action: 'mini', source: 'eventListener'});
}

const onClickAsideContainerHandler = (event) => {
  if (event.target.closest('.display-options'))
    return;
  const asideContainer = document.querySelector('.aside__container');
  const isHomeMenuButtonActive =
    Boolean(document.querySelector(
      '.aside__navigation-menu__item.aside__active-menu[data-menu-item="3dModel"]'
    ));
  if (event.target !== asideContainer && !isHomeMenuButtonActive) {
    toggleMenuWidth({action: 'mini', source: settingsData.activeViewMode === ViewMode.Orbit ? 'orbit' : 'eventListener'});
    return;
  }

  asideContainer.classList.contains('minimized')
    ? toggleMenuWidth({action: 'full', source: settingsData.activeViewMode === ViewMode.Orbit ? 'orbit' : 'eventListener'})
    : toggleMenuWidth({action: 'mini', source: settingsData.activeViewMode === ViewMode.Orbit ? 'orbit' : 'eventListener'});
}

export const addAsideContainerOnMouseHandlers = () => {
  const asideContainer = document.querySelector('.aside__container');
  if (!asideContainer || isMobile || isTablet)
    return;

  asideContainer.addEventListener('mouseenter', onMouseOverAsideContainerHandler);
  asideContainer.addEventListener('mouseleave', onMouseOutAsideContainerHandler);
  onMouseOutAsideContainerHandler();
}

export const addOnClickAsideContainerMinimizerHandler = () => {
  const asideContainer = document.querySelector('.aside__container');
  if (!asideContainer || !isTablet || isMobile || isDesktop)
    return;

  document.body.addEventListener('click', onClickAsideContainerHandler);
}

export function preventMenuWidthAnimation (state) {
  blockMenuWidthAnimation = state;
}

export const removeAsideContainerOnMouseHandlers = () => {
  const asideContainer = document.querySelector('.aside__container');
  if (!asideContainer || isMobile || isTablet)
    return;

  asideContainer.removeEventListener('mouseenter', onMouseOverAsideContainerHandler);
  asideContainer.removeEventListener('mouseleave', onMouseOutAsideContainerHandler);
}

export function hideAsideContainer() {
  const menu = document.querySelector('.aside__container');
  menu.classList.add('invisible');
}

export function showAsideContainer() {
  const menu = document.querySelector('.aside__container');
  menu.classList.remove('invisible');
}
